'use client';

import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import { Box, Chip, Stack, Typography } from '@/primitives';
import { blue, slate } from '@/lib/colours';
import { FadeInWhenVisible } from './FadeInWhenVisible';
import {
  landingComingSoonItems,
  landingComingSoonSection,
} from './homeLandingContent';
import { lightSectionBg, sectionShell } from './homeLandingSectionSx';

export function LandingComingSoon() {
  return (
    <Box
      component="section"
      aria-labelledby="landing-coming-soon-title"
      sx={{
        py: { xs: 8, md: 10 },
        borderTop: `1px solid ${slate[200]}`,
        ...lightSectionBg,
      }}
    >
      <Box sx={sectionShell}>
        <FadeInWhenVisible>
          <Stack
            alignItems="center"
            spacing={1}
            sx={{ mb: { xs: 4, md: 5 }, textAlign: 'center', width: '100%' }}
          >
            <Typography
              color={blue[700]}
              sx={{
                fontWeight: 600,
                letterSpacing: '0.08em',
                fontSize: '0.75rem',
                textAlign: 'center',
              }}
              variant="labelmedium"
            >
              Roadmap
            </Typography>
            <Typography
              color={slate[900]}
              component="h2"
              id="landing-coming-soon-title"
              sx={{ maxWidth: 720, mx: 'auto', textAlign: 'center' }}
              variant="headlinelarge"
            >
              {landingComingSoonSection.title}
            </Typography>
            <Typography
              color={slate[600]}
              sx={{ maxWidth: 640, mx: 'auto', mt: 0.5, textAlign: 'center' }}
              variant="bodylarge"
            >
              {landingComingSoonSection.subtitle}
            </Typography>
          </Stack>
        </FadeInWhenVisible>

        <Stack spacing={{ xs: 3, md: 3.5 }}>
          {landingComingSoonItems.map((item, index) => (
            <FadeInWhenVisible key={item.title} delay={index * 0.06}>
              <Box
                sx={{
                  p: { xs: 2.5, md: 3.5 },
                  borderRadius: '16px',
                  border: `1px solid ${slate[200]}`,
                  backgroundColor: slate[50],
                  boxShadow: `0 1px 0 ${slate[200]}`,
                }}
              >
                <Stack spacing={2}>
                  <Stack
                    alignItems={{ xs: 'flex-start', sm: 'center' }}
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="space-between"
                    spacing={1.5}
                  >
                    <Stack alignItems="center" direction="row" spacing={1.25}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: 40,
                          height: 40,
                          borderRadius: '10px',
                          backgroundColor: blue[50],
                          color: blue[700],
                        }}
                      >
                        <EventAvailableOutlinedIcon sx={{ fontSize: 22 }} />
                      </Box>
                      <Typography color={slate[900]} variant="headlinesmall">
                        {item.title}
                      </Typography>
                    </Stack>
                    <Chip
                      label={item.timingLabel}
                      size="small"
                      sx={{
                        borderRadius: '8px',
                        border: `1px solid ${blue[200]}`,
                        backgroundColor: blue[50],
                        color: blue[900],
                        fontWeight: 600,
                        '& .MuiChip-label': { px: 1.25 },
                      }}
                      variant="outlined"
                    />
                  </Stack>
                  <Typography color={slate[700]} variant="bodymedium">
                    {item.description}
                  </Typography>
                </Stack>
              </Box>
            </FadeInWhenVisible>
          ))}
        </Stack>
      </Box>
    </Box>
  );
}
